import React from 'react'
import { FlexRow, Tooltip } from 'components/lib'
import { PhoneTreeCondition } from '@super-software-inc/foundation'

interface PhoneTreeConditionPillsProps {
  conditions: PhoneTreeCondition[]
}

const PhoneTreeConditionPills: React.FC<PhoneTreeConditionPillsProps> = ({
  conditions,
}) => (
  <FlexRow style={{ gap: '8px', flexWrap: 'wrap' }}>
    {conditions.map((condition, index) => (
      <Tooltip
        key={condition.condition}
        placement="bottomLeft"
        overlay={
          <div style={{ padding: '8px' }}>
            <pre
              style={{
                margin: 0,
                whiteSpace: 'pre-wrap',
                fontFamily: 'monospace',
                fontSize: '12px',
                color: '#374151',
              }}
            >
              {JSON.stringify(condition, null, 2)}
            </pre>
          </div>
        }
      >
        <div
          style={{
            backgroundColor: '#F3F4F6',
            padding: '4px 12px',
            borderRadius: '16px',
            fontSize: '14px',
            color: '#374151',
            cursor: 'help',
            maxWidth: '200px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          Condition {index + 1}
        </div>
      </Tooltip>
    ))}
  </FlexRow>
)

export default PhoneTreeConditionPills
